import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SettingsService } from '@app/core/settings/settings.service';
import { loadProgram } from '@app/core/store/programs/actions';
import { selectError, selectProgram } from '@app/core/store/programs/selectors';

@Injectable({
  providedIn: 'root',
})
export class ProgramsFacade {
  protected store = inject(Store);
  protected settingsService = inject(SettingsService);

  public readonly program$ = this.store.select(selectProgram);
  public readonly error$ = this.store.select(selectError);

  public loadProgram(id: number): void {
    this.store.dispatch(loadProgram({ id }));
  }
}
